import React from "react";
import {
  Box,
  FormControl,
  TextField,
  Checkbox,
  styled
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import ModalTwoButtons from '../../../components/Modal/ModalTwoButtons';
import STType from "../../../api/StationaryTesting/STType";

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  marginBottom: "20px",
  gap: "20px",
  justifyContent: "normal!important"
}));

const StyledTextField = styled(TextField)(() => ({
  width: "35rem"
}));

const StyledFormControl = styled(FormControl)(() => ({
  display: 'flex',
  width: "50rem"
}));

const StyledDiv = styled('div')({
  display: 'flex',
  justifyContent: "space-between"
});

const STTypeForm = ({ infoData, setInfoData, invalidField, handleChangeSTTypeFilter, canEdit }) => {

  const [modalTwoButtonsOpen, setModalTwoButtonsOpen] = React.useState(false);

  function findType() {
    handleChangeSTTypeFilter(infoData.typeName);
    closeModalTwoButtonsOpen();
  }

  function closeModalTwoButtonsOpen() {
    setModalTwoButtonsOpen(false);
  }

  function checkExistingType(type) {

    if (type) {
      STType.get(type).then((typeExists) => {
        if ((typeExists !== undefined && typeExists !== null))
          setModalTwoButtonsOpen(true)
      });
    }
  }

  return (

    <div>
      <StyledDiv>
        <div>
          <StyledBox sx={{ flexDirection: 'column' }}>
            <StyledFormControl sx={{ m: 1 }} variant='outlined'>

              <StyledBox sx={{ justifyContent: "space-between" }}>
                <StyledTextField
                  onChange={e => {
                    setInfoData(() => ({
                      ...infoData,
                      typeName: e.target.value
                    }))
                  }}
                  onBlur={e => {
                    checkExistingType(e.target.value)
                  }}
                  value={infoData.typeName}
                  id="type-name"
                  label="Type Name"
                  variant="outlined" size="small" margin="none"
                  error={invalidField.typeName.length === 0 ? false : true}
                  disabled={infoData.id || !canEdit ? true : false}
                  helperText={invalidField.typeName}
                  inputProps={{ maxLength: 50 }}
                />

                <FormControlLabel
                  label="Active"
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    isActive: e.target.checked
                  }))}
                  checked={infoData.isActive}
                  disabled={!canEdit}
                  control={<Checkbox />}
                />               
              </StyledBox>    

               <StyledBox sx={{ justifyContent: "space-between" }}>
                <StyledTextField
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    description: e.target.value
                  }))}
                  id="type-description"
                  label="Type Description"
                  variant="outlined" size="small" margin="none"
                  value={infoData.description}
                  inputProps={{ maxLength: 200 }}
                  disabled={!canEdit}
                />

              </StyledBox>  

            </StyledFormControl>
          </StyledBox>

        </div>

      </StyledDiv>

      <ModalTwoButtons title={'Warning'} button1Text={'No'} button1Action={closeModalTwoButtonsOpen} button2Text={'Yes'} button2Action={findType} open={modalTwoButtonsOpen} setOpen={setModalTwoButtonsOpen}>
        <label>
          This ST Type already exist, would you like to use it?
        </label>
      </ModalTwoButtons>

    </div>

  );
};

export default STTypeForm;
